import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trackLocationView } from "../utils/analytics";
import "../styles/HomePage.css";

import OrderCta from "../components/OrderCta";

const HomePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">{t("home.heroTitle")}</h1>
          <p className="hero-description">{t("home.heroDescription")}</p>
          <p className="hero-byow">{t("home.byow")}</p>
          <OrderCta variant="home" />
        </div>
      </section>

      {/* Locations Section */}
      <section className="locations-section">
        <video className="locations-video-bg" autoPlay loop muted playsInline>
          <source
            src="https://cdn.jsdelivr.net/gh/mariusroyale/static-assets@main/cava/webm/olivetree-optimized.webm"
            type="video/webm"
          />
        </video>
        <div className="container">
          <h2 className="locations-title">{t("locations.chooseLocation")}</h2>
          <div className="locations-grid">
            {/* Montreal Location */}
            <Link
              to="/montreal"
              className="location-card"
              onClick={() => trackLocationView("montreal")}
            >
              <div className="location-card-content">
                <h2 className="location-card-title">MONTRÉAL</h2>
                <p className="location-card-tagline">
                  {t("locations.montreal.tagline")}
                </p>
                <div className="location-card-cta">
                  <span className="location-cta-text">
                    {t("common.viewMenu").toUpperCase()}
                  </span>
                  <span className="location-card-arrow">→</span>
                </div>
              </div>
            </Link>

            {/* Delson Location */}
            <Link
              to="/delson"
              className="location-card"
              onClick={() => trackLocationView("delson")}
            >
              <div className="location-card-content">
                <h2 className="location-card-title">DELSON</h2>
                <p className="location-card-tagline">
                  {t("locations.delson.tagline")}
                </p>
                <div className="location-card-cta">
                  <span className="location-cta-text">
                    {t("common.viewMenu").toUpperCase()}
                  </span>
                  <span className="location-card-arrow">→</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
